// How big the document is, in the unit an operator actually thinks in. Pages when
// the format has them, characters otherwise (xlsx, plain text, an email body) -
// and nothing at all when neither is known, rather than a misleading "0". The row
// button and the panel header both use it, so they agree.
export const sizeLabel = (
  chars: number | null | undefined,
  pages: number | null | undefined,
): string | null => {
  if (pages != null && pages > 0) return `${pages.toLocaleString()} page${pages === 1 ? "" : "s"}`;
  if (chars != null && chars > 0) return `${chars.toLocaleString()} chars`;
  return null;
};
